import { ContextModalProps } from '@mantine/modals'
import ShortageForm from 'components/shortage/ShortageForm'
import { useUpdateShortage } from 'hooks/shortage'
import { UpdateShortage } from 'types/shortage'

type Props = {
  shortage: UpdateShortage & { productSymbol: string }
}

export default function UpdateShortageModal({ context, id, innerProps: { shortage } }: ContextModalProps<Props>) {
  const updateShortage = useUpdateShortage()

  return (
    <ShortageForm
      onSubmit={async (values: UpdateShortage) => {
        await updateShortage.mutateAsync({ ...values, id: shortage.id })
      }}
      onCancel={() => context.closeModal(id)}
      initialValues={shortage}
    />
  )
}
